<template>
  <div class="cockpit-tbi-chart" data-testid="cockpit-tbi-chart">
    <div
      v-if="isEmpty"
      class="text-sm text-[var(--color-disabled)] py-8 text-center h-48 flex items-center justify-center"
    >
      {{ $t('UserProjects.cockpit.chart.tbiEmpty') }}
    </div>
    <div v-else class="cockpit-tbi-chart__canvas">
      <Line :data="chartData" :options="chartOptions" />
    </div>
    <div class="flex items-center gap-4 mt-3 text-[12px] text-[#6B6B6B]">
      <span class="flex items-center gap-1.5">
        <span class="w-2.5 h-2.5 rounded-full bg-[#c026a8]" />
        {{ $t('UserProjects.cockpit.chart.legendTbi') }}
      </span>
      <span class="flex items-center gap-1.5">
        <span class="w-4 h-0.5 bg-[#22C55E]" />
        {{ $t('UserProjects.cockpit.chart.legendTbiTarget') }}
      </span>
    </div>
  </div>
</template>

<script>
import { Line } from 'vue-chartjs';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip);

const targetPlugin = {
  id: 'cockpitTbiTarget',
  afterDraw(chart) {
    const { ctx, chartArea, scales } = chart;
    const yScale = scales.y;
    if (!yScale || !chartArea) return;
    const y = yScale.getPixelForValue(70);
    ctx.save();
    ctx.strokeStyle = '#22C55E';
    ctx.lineWidth = 1.5;
    ctx.setLineDash([6, 4]);
    ctx.beginPath();
    ctx.moveTo(chartArea.left, y);
    ctx.lineTo(chartArea.right, y);
    ctx.stroke();
    ctx.restore();
  },
};

ChartJS.register(targetPlugin);

export default {
  name: 'CockpitTbiTrendChart',
  components: { Line },
  props: {
    bars: { type: Array, default: () => [] },
  },
  computed: {
    isEmpty() {
      return !(this.bars || []).some((b) => typeof b.tbi === 'number');
    },
    chartData() {
      return {
        labels: (this.bars || []).map((b) => b.label),
        datasets: [
          {
            label: 'TBI',
            data: (this.bars || []).map((b) => (typeof b.tbi === 'number' ? b.tbi : null)),
            borderColor: '#c026a8',
            backgroundColor: '#c026a8',
            pointRadius: 3,
            pointHoverRadius: 5,
            borderWidth: 2,
            tension: 0.25,
            spanGaps: true,
          },
        ],
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label(ctx) {
                const v = ctx.parsed.y;
                return v == null ? '—' : `${v}`;
              },
            },
          },
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: { color: '#ABABAB', font: { size: 11 } },
          },
          y: {
            min: 0,
            max: 100,
            ticks: {
              stepSize: 25,
              color: '#ABABAB',
              font: { size: 11 },
            },
            grid: { color: '#E5E5E5' },
          },
        },
      };
    },
  },
};
</script>

<style scoped>
.cockpit-tbi-chart__canvas {
  height: 180px;
  position: relative;
}
</style>
